import {EventBus} from 'js/event-bus'
import ComsAPI from 'js/api/commons'

export default {

    /** $emit **/

    routerToHome () {
        EventBus.$emit('routerToHome')
    },
    startProgress () {
        EventBus.$emit('startProgress')
    },
    doneProgress () {
        EventBus.$emit('doneProgress')
    },
    startSpinner () {
        EventBus.$emit('startSpinner')
    },
    doneSpinner () {
        EventBus.$emit('doneSpinner')
    },
    openReplyTech ({commit}, data) {
        EventBus.$emit('openReplyTech', data)
    },
    openIntvNote ({commit}, data) {
        EventBus.$emit('openIntvNote', data)
    },
    getUser ({commit}) {
        commit('setUserLoadStatus', 1)
        ComsAPI.getUser()
            .then(resp => {
                commit('setUser', resp.data)
                commit('setUserLoadStatus', 2)
            })
            .catch(err => {
                commit('setUser', {})
                commit('setUserLoadStatus', 3)
            })
    },
    setRefreshArr ({commit}, item) {
        commit('setRefreshArr', item)
    },
    resetRefreshArr ({commit}, item) {
        commit('resetRefreshArr', item)
    },

    /** リスト画面共通 **/
    loadListObj ({commit}, data) {
        commit('setListObjLoadStatus', 1)

        ComsAPI.loadListObj(data)
            .then(resp => {
                commit('setListObj',resp)
                commit('setListObjLoadStatus', 2)
            })
            .catch(err => {
                commit('setListObj', {})
                commit('setListObjLoadStatus', 3)
            })
    },
    // 新規・更新をリストへ反映
    reflectList ({commit}, data) {
        commit('reflectList', data)
    },
    // 特定対象更新
    setListObjSpecificItem ({commit}, data) {
        commit('setListObjSpecificItem', data)
    },
    resetListObj ({commit}) {
        commit('resetListObj')
    },
    // 子画面もlistObj利用する時、親画面のデータが上書きされる為、保存して置く
    setListObjKeep ({commit}) {
        commit('setListObjKeep')
    },
    // 子画面で処理した結果を親画面へ反映必要の場合、
    // 親画面→小画面へ遷移後、子画面で画面リフレッシュしたら、親画面のデータが
    // なくなる、子画面で処理完了後、データ反映の時エラー発生
    setListObjSession ({commit}) {
        commit('setListObjSession')
    },
    delItemFromList ({commit}, data) {
        commit('delItemFromList', data)
    },
    backListFromKeep ({commit}) {
        commit('backListFromKeep')
    },
    loadListObjSeeMore ({commit}, data) {
        commit('setListObjSeeMoreLoadStatus', 1)

        ComsAPI.loadListObjSeeMore(data)
            .then(resp => {
                commit('setListObjAddSeeMore',resp)
                commit('setListObjSeeMoreLoadStatus', 2)
            })
            .catch(err => {
                commit('setListObjSeeMoreLoadStatus', 3)
            })
    },
    /** 削除しかないメニューの場合  **/
    listItemDelete ({commit}, data) {
        commit('setListItemDeleteStatus', 1)

        ComsAPI.listItemDelete(data)
            .then(resp => {
                commit('setListItemDeleteStatus', 2)
            })
            .catch(err => {
                commit('setListItemDeleteStatus', 3)
            })
    },

    /** 個人情報取得 **/
    loadPrivateInfo ({commit}, data) {
        commit('setPrivateInfoLoadStatus', 1)

        ComsAPI.loadPrivateInfo(data)
            .then(resp => {
                commit('setPrivateInfo',resp)
                commit('setPrivateInfoLoadStatus', 2)
            })
            .catch(err => {
                commit('setPrivateInfo',{})
                commit('setPrivateInfoLoadStatus', 3)
            })
    },

    /** 郵便番号住所取得 **/
//    loadAddress ({commit}, data) {
//        commit('setAddressInfoLoadStatus', 1)
//
//        ComsAPI.loadAddress(data)
//            .then(resp => {
//                if (resp.data.results) {
//                    commit('clearZipCodeErrors', {})
//                } else {
//                    commit('setZipErrNotFound', data.myNm)
//                }
//
//                commit('setAddressInfo',resp)
//                commit('setMyNm',data.myNm)
//                commit('setAddressInfoLoadStatus', 2)
//            })
//            .catch(err => {
//                commit('setZipCodeErrors', err.response.data.errors)
//                commit('setAddressInfoLoadStatus', 3)
//            })
//    },

    /** カスタマイズシェアURL取得(案件・要員) **/
    loadCustShareUrl ({commit}, data) {
        commit('setCustShareUrlLoadStatus', 1)

        ComsAPI.loadCustShareUrl(data)
            .then(resp => {
                commit('setCustShareUrl',resp)
                commit('setCustShareUrlLoadStatus', 2)
            })
            .catch(err => {
                commit('setCustShareUrl',{})
                commit('setCustShareUrlLoadStatus', 3)
            })
    },

    /** Unique チェック
     * val:対象項目値 
     * info: 対象レコードkey + 操作(0:登録、1:更新)
     *
     */
    uniqueCheck ({commit}, data) {
        commit('setUniqueCheckStatus', 1)
        ComsAPI.uniqueCheck(data)
            .then(resp => {
                commit('setUniqueCheckErr', resp.data)
                commit('setUniqueCheckStatus', 2)
            })
            .catch(err => {
                commit('setUniqueCheckErr', {})
                commit('setUniqueCheckStatus', 3)
            })
    },

    /**
     * selectGroupメール送信
     *
     */
    sendMailCommon ({commit}, data) {
        commit('setSendMailComStatus', 1)
        ComsAPI.sendMailCommon(data)
            .then(resp => {
                commit('setSendMailComRes', resp)
                commit('setSendMailComStatus', 2)
            })
            .catch(err => {
                commit('setSendMailComStatus', 3)
            })
    },

    /** 応募詳細メッセージ **/
    addApplyHisMsg ({commit}, data) {
        commit('setAddApplyHisMsgStatus', 1)
        ComsAPI.addApplyHisMsg(data)
            .then(resp => {
                commit('setAddApplyHisMsg', resp.data.msg)
                commit('setAddApplyHisMsgStatus', 2)
            })
            .catch(err => {
                commit('setAddApplyHisMsgStatus', 3)
            })
    },

}
